import React from 'react';
import { useRef, useEffect, useState } from 'react';
import { Component } from 'react';
import ChatBot, { Loading } from 'react-simple-chatbot';
import { ThemeProvider } from 'styled-components';
import chatBot from './chat-bot.png'
import axios from 'axios'
import Button from 'react-bootstrap/Button';

const SERVER = `https://volunteer-server.onrender.com`
// const SERVER = `http://localhost:8800`
// class DBPedia extends Component {
//     constructor(props) {
//       super(props);
  
//       this.state = {
//         loading: true,
//         result: "",
//         trigger: false,
//       };
  
//       this.triggetNext = this.triggetNext.bind(this);
//     }
  
//      componentWillMount () {
//       const self = this;
//       const { steps } = this.props;
//       const ask = steps.ask.value;
//       axios.post('http://localhost:8800/api/ask',{text:ask}).then((res)=>{
//         self.setState({loading: false,result:res.data})
//       }).catch((e)=>{
//         self.setState({loading: false,result:'Error'})
//       })
      
//     }
  

  
//     render() {
//       const { loading, result } = this.state;
  
//       return (
//         <div className="dbpedia">
//           { loading ? <Loading /> : result }
//           {/* {
//             !loading &&
//             <div
//               style={{
//                 textAlign: 'center',
//                 marginTop: 20,
//               }}
//             >
//               {
//                 !trigger &&
//                 <button
//                   onClick={() => this.triggetNext()}
//                 >
//                   Search Again
//                 </button>
//               }
//             </div>
//           } */}
//         </div>
//       );
//     }
//   }

  function DBPedia2(props) {
    const { steps } = props;
    const ask = steps.ask.value;
    const [result,setResult] = useState("")
    const [loading,setLoad] = useState(true)
    const [trigger,setTrigger] = useState(false)
    const parseData = async()=> {
        const result = await axios.post(`${SERVER}/api/ask`,{text:ask});
        console.log(result)
        setResult(result.data)
        setLoad(false)
        
      }
    useEffect(() => {
        parseData()
      }, []);

      const triggetNext = () => {
        setTrigger(true);
        props.triggerNextStep();
      };

  return (
        <div className="dbpedia" >
          { loading ? <Loading /> : 
          <div style={{fontSize: 12}}>
            {result.data}
          </div>
          
          }
          {
          !loading &&
          <div
            style={{
              textAlign: 'center',
              marginTop: 20,
            }}
          >
            {
              !trigger &&
              <Button
                onClick={() => triggetNext()}
              >
                Шукати знову
              </Button>
            }
          </div>
        }
        </div>
  )
}
function DBPedia3(props) {
  const { steps } = props;
  const [result,setResult] = useState("")
  const [loading,setLoad] = useState(true)
  const [trigger,setTrigger] = useState(false)
  const parseData = async()=> {
      const result = await axios.post(`${SERVER}/api/ask`,{text:'Скільки коштує перевезення службових собак ?'});
      console.log(result)
      setResult(result.data)
      setLoad(false)
      
    }
  useEffect(() => {
      parseData()
    }, []);

    const triggetNext = () => {
      setTrigger(true);
      props.triggerNextStep();
    };

return (
      <div className="dbpedia" >
        { loading ? <Loading /> : 
        <div style={{fontSize: 12}}>
          {result.data}
        </div>
        
        }
        {
        !loading &&
        <div
          style={{
            textAlign: 'center',
            marginTop: 20,
          }}
        >
          {
            !trigger &&
            <Button
              onClick={() => triggetNext()}
            >
              Шукати знову
            </Button>
          }
        </div>
      }
      </div>
)
}
function DBPedia4(props) {
  const { steps } = props;
  const [result,setResult] = useState("")
  const [loading,setLoad] = useState(true)
  const [trigger,setTrigger] = useState(false)
  const parseData = async()=> {
      const result = await axios.post(`${SERVER}/api/ask`,{text:"Чи можна провозити корм для домашніх тварин в літаку у ручній поклажі?"});
      console.log(result)
      setResult(result.data)
      setLoad(false)
      
    }
  useEffect(() => {
      parseData()
    }, []);

    const triggetNext = () => {
      setTrigger(true);
      props.triggerNextStep();
    };

return (
      <div className="dbpedia" >
        { loading ? <Loading /> : 
        <div style={{fontSize: 12}}>
          {result.data}
        </div>
        
        }
        {
        !loading &&
        <div
          style={{
            textAlign: 'center',
            marginTop: 20,
          }}
        >
          {
            !trigger &&
            <Button
              onClick={() => triggetNext()}
            >
              Шукати знову
            </Button>
          }
        </div>
      }
      </div>
)
}
const steps = [
    {
        id: '0',
        message: 'Привіт єВолонтер!',
 
        // This calls the next id
        // i.e. id 1 in this case
        trigger: '1',
    }, {
        id: '1',
 
        // This message appears in
        // the bot chat bubble
        message: 'Будь-ласка впишіть як до вас звертатися ...',
        trigger: '2'
    }, {
        id: '2',
 
        // Here we want the user
        // to enter input
        user: true,
        trigger: '3',
    }, {
        id: '3',
        message: "Вітаю {previousValue}, чим я можу вам допомогти ?",
        trigger: '4'
    }, {
        id: '4',
        options: [
             
            {value: 1, label: 'Написати боту запитання',trigger:'5'},
            {value: 2, label: 'Обрати готові питання',trigger:'8' },
 
        ]
    },
    {
        id: '5',
        message: "Впишіть запитання ...",
        trigger: 'ask'
    },
    {
        id: 'ask',
 
        // Here we want the user
        // to enter input
        user: true,
        trigger: '7',
    },
    {
        id: '7',
        component: <DBPedia2 />,
        waitAction: true,
        trigger: '3',
    },
    {
      id: '8',
      options: [ 
        {value: 1, label: 'Чи можна провозити корм для домашніх тварин в літаку у ручній поклажі?',trigger:'9'},
        {value: 2, label: 'Скільки коштує перевезення службових собак ?',trigger:'10' },
    ]
    },
    {
      id: '9',
      component: <DBPedia4 />,
      waitAction: true,
      trigger: '3',
    },
    {
      id: '10',
      component: <DBPedia3 />,
      waitAction: true,
      trigger: '3',
    }
];
//   const theme = {
//     background: '#C9FF8F',
//     headerBgColor: '#197B22',
//     headerFontSize: '20px',
//     botBubbleColor: '#0F3789',
//     headerFontColor: 'white',
//     botFontColor: 'white',
//     userBubbleColor: '#FF5733',
//     userFontColor: 'white',
//   };
  
  // Set some properties of the bot
  const config = {
    botAvatar: chatBot,
    floating: true,
  };
function ChatBotComponent(props) {
    return (
       

                <ChatBot
                    // This appears as the header
                    // text for the chat bot
                    headerTitle="єВолонтер"
                    steps={steps}
                    {...config}
 
                />
          
     
    );
}

export default ChatBotComponent;